import React from 'react';

import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

import Box from '../Box/Box';
import Icon from './Icon';
import { TIconCompoundProps } from './types';

const IconCompound = ({ name, size, color, ...rest }: TIconCompoundProps) => {
  const conditionalProps = filterConditionalKeyValues({ modifiers: [size] });

  return (
    <Box {...rest} {...conditionalProps} as="div" name="IconCompound">
      <Icon name={name} size={size} color={color} />
      <Icon name="verified" size={size} color="signal-success-default" />
    </Box>
  );
};

export default IconCompound;
